<template>
  <div class="std-page-container" :class="[`std-page-container--${type}`]">
    <!-- 标题插槽 -->
    <slot name="title"></slot>
    <div class="std-page-container__body">
      <!-- 内容插槽 -->
      <slot name="content"></slot>
    </div>
    <div class="std-page-container__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StdPageContainer',
    props: {
      type: {
        type: String,
        default: 'default'
      }
    }
  };
</script>
<style lang="less">
  .std-page-container {
    width: 100%;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0%;
    display: flex;
    flex-direction: column;

    &__body {
      position: relative;
      width: 100%;
      flex: 1;
      background-color: #fff;
      display: flex;
      box-sizing: border-box;
    }

    .vh-table {
      width: 100%;
      // overflow: auto;
      // max-width: 100%;
      // overflow-x: auto;

      .vh-table__body-wrapper {
        min-height: 100%;
      }

      // 解决vh-table宽度无限延长问题 .vh-table__header-wrapper table,
      .vh-table__body-wrapper table {
        // width: 100% !important;
        // overflow: auto;
        // max-width: 100%;
      }

      .vh-table__empty-text {
        line-height: 1;
      }
    }

    .vh-table .vh-table__row .cell {
      .image-preview {
        height: 70px;
        border-radius: 4px;
        box-sizing: border-box;
        border: 1px solid #f0f0f0;
        position: relative;

        .cover-mask {
          position: absolute;
          background: red;
          height: 20px;
          font-size: 12px;
          color: #fff;
          left: 1px;
          bottom: 1px;
          padding: 0 8px;
          background: rgba(0, 0, 0, 0.65);
          border-bottom-left-radius: 4px;
          border-top-right-radius: 12px;
          box-sizing: border-box;

          .vh-radio {
            color: #fff;
            box-sizing: border-box;

            .vh-radio__inner {
              width: 12px;
              height: 12px;

              &::after {
                width: 6px;
                height: 6px;
              }
            }
            .vh-radio__label {
              font-size: 12px;
              padding-left: 4px;
            }
          }
        }
      }

      .vh-image {
        border-radius: 4px;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: contain;
      }
    }

    // 创建页类型
    &--create {
      .std-page-container__body {
        padding: 48px 16px 0 48px;
      }
    }

    // 列表页类型
    &--list {
      .std-page-container__body {
        padding: 24px;
        display: flex;
        flex-direction: column;
      }
    }

    // 有tabs
    &--tabs {
      .std-page-container__body {
        width: 100%;
        padding: 0;

        & > .vh-tabs {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;

          // tab头
          .vh-tabs__header {
            height: 48px;
            line-height: 48px;
            margin: 0;
            padding: 0 20px;

            .vh-tabs__item {
              .saasicon_help_m {
                color: #999;
              }
            }
          }
        }

        .vh-tabs__content {
          padding: 0;
          flex: 1;

          .vh-tab-pane {
            position: relative;
            min-height: 100%;
            padding: 16px 24px 24px 24px;
            display: flex;
            flex-direction: column;

            &.tab-pane--create {
              display: block;
              padding: 48px 16px 24px 48px;
            }
          }
        }
      }
    }
  }
</style>
